import {defineStore} from 'pinia';
import {ModuleContract} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import contractAPI from '@/apis/di/contractAPI';
const contractStore = new BaseDictionaryStore(contractAPI);
export const useContractStore = defineStore(ModuleContract, {
  state: () => ({
    ...contractStore.state,
    _config: {
      key: 'contract_id',
      code: 'contract_code',
      name: 'contract_no',
      table: 'di_contract',
      quickFollow: 'active',
      moduleName: 'Hợp đồng',
      defaultSort: 'contract_code',
    },
    moduleName: 'contract',
  }),
  actions: {...contractStore.action,
    /**
     * Lấy danh sách chứng từ sử dụng hợp đồng
     * ndquang1 12.01.2023
     */
    getVoucherReference(idContract) {
        return contractAPI.getVoucherReference(idContract);
    },
  },
  getters: {
    ...contractStore.getters,
  },
});
